var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccordioPsycho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5V8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5H16C17.5913 2.5 19.1174 3.13214 20.2426 4.25736C21.3679 5.38258 22 6.9087 22 8.5V16.5C22 18.0913 21.3679 19.6174 20.2426 20.7426C19.1174 21.8679 17.5913 22.5 16 22.5H8C6.4087 22.5 4.88258 21.8679 3.75736 20.7426C2.63214 19.6174 2 18.0913 2 16.5Z",
    stroke: "#29292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5V11.5C6 10.9696 6.21071 10.4609 6.58579 10.0858C6.96086 9.71071 7.46957 9.5 8 9.5H11C11.5304 9.5 12.0391 9.71071 12.4142 10.0858C12.7893 10.4609 13 10.9696 13 11.5V13.5C13 14.0304 12.7893 14.5391 12.4142 14.9142C12.0391 15.2893 11.5304 15.5 11 15.5H8C7.46957 15.5 6.96086 15.2893 6.58579 14.9142C6.21071 14.5391 6 14.0304 6 13.5Z",
    stroke: "#29292E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0414 9.71961L13.9744 12.0196C13.8999 12.0755 13.8394 12.148 13.7977 12.2313C13.7561 12.3146 13.7344 12.4065 13.7344 12.4996C13.7344 12.5928 13.7561 12.6846 13.7977 12.7679C13.8394 12.8513 13.8999 12.9237 13.9744 12.9796L17.0414 15.2796C17.1305 15.3465 17.2365 15.3872 17.3475 15.3972C17.4585 15.4072 17.57 15.3861 17.6697 15.3363C17.7694 15.2864 17.8532 15.2098 17.9118 15.115C17.9703 15.0203 18.0014 14.911 18.0014 14.7996V10.1996C18.0014 10.0882 17.9703 9.97896 17.9118 9.88417C17.8532 9.78939 17.7694 9.71278 17.6697 9.66295C17.57 9.61312 17.4585 9.59203 17.3475 9.60203C17.2365 9.61204 17.1305 9.65275 17.0414 9.71961Z",
    stroke: "#29292E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccordioPsycho);
export default __webpack_public_path__ + "static/media/IconAccordioPsycho.583a554b2dd750ad1fd05c41cbc57f3a.svg";
export { ForwardRef as ReactComponent };